import { Injectable } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { CurrentUser } from './current-user';
import { MatSnackBar } from '@angular/material/snack-bar';

@Injectable({providedIn: 'root'})
export class ErrorManagerService {
    constructor(
        private currentUser: CurrentUser,
        private translater: TranslateService,
        private toaster: MatSnackBar,
    ) { }

    public error(error: any, duration = 5000) {
        const key = this.getErrorMessage(error);
        const message = this.translater.instant(key);
        // console.log(key, message);
        this.toaster.open(message, '', {duration});
    }

    private getErrorMessage(error: any): string {

        if (typeof error === 'string') {
            return error;
        }

        if (typeof error === 'object') {
            if (error.error && error.error.errors && typeof error.error.errors === 'string') {
                return error.error.errors;
            } if (error.error && error.error.message && typeof error.error.message === 'string') {
                return error.error.message;
            } else {
            console.error("ErrorManager : ", error);
                return 'error_manager_unknown_error';
            }
        }

      console.error("common provider", error);
        return 'error_manager_unknown_error';
    }
}
